const random = require('canvas-sketch-util/random');
const seedRandom = require('seed-random');
const ohash = require('object-hash');
const alea = require('alea')
const rough = require('roughjs/bundled/rough.cjs.js')
const { createNoise2D } = require('simplex-noise')
const palettes = require('./automata-colors')

var seed, 
    seeded;

window.$fxhashFeatures = {}

function setFeature(key, value) {
  console.log(`Feature: ${key}: ${value}`)
  if (window.$fxhashFeatures[key] != undefined)
    window.$fxhashFeatures[key] += value
  else
    window.$fxhashFeatures[key] = value
}

// Helpsers

const TWO_PI = 2 * Math.PI;

function dist(x1, y1, x2, y2) {
    var dx = x2 - x1;
    var dy = y2 - y1;
    return Math.sqrt(dx * dx + dy * dy);
}

function map(value, start1, stop1, start2, stop2) {
    return start2 + (stop2 - start2) * ((value - start1) / (stop1 - start1));
}

const rgbaColor = (c, opacity=1) => {
  return `rgba(${c[0]},${c[1]},${c[2]},${opacity})`
}

let c1, c2;
let _c1, _c2;
let colors;
let bgColorLayer1;
let mainPalette;
let noise;
let exportscale = 3;
const sketch = ({ scale, show }) => {
    seed = window.fxhash || Math.random()*1000
//    seed = 'ooa2kXKwjdoyHcnre9KmVVW85vACJxexHDK849f6cX5z2GykwCN'
//  seed = 'ooTw2jGrLoD6bjhDLCugJUBVFTruNjY5C7E6UepL4sHWRZoCbKY' // potensiell
//  seed = 'oo7ovJBp8BAMNVxDJLu1AKc1AayuVS6HD3vjFp26PfWyMJqj9Li' // potensiell
//  seed = 'ooNGFn9arq7u6ws5vRF6b89W196RJB5br5hGGHJuTtxDKiAyc2F' // potensiell
//  seed = 'ooERdmjmV5RtPMPqK7c74FAJgSS5s53bntzrw6uVjueLxJL8BsD' // potensiell
//  seed = 'oosmmH6YoHuSW9yihPJvHKnrsfhwFoR55UqKy2ToJLPF6YrFXzU' // potensiell
//  seed = 'oory7qw9nMPmayuKppScL9DeWeh6Qtiouc7EqRXYeEtQWsexW8a' // cute
    console.log('seed', seed)

    // Reset globals
    c1=undefined 
    c2=undefined
    _c1=undefined
    _c2=undefined
    colors=undefined
    bgColorLayer1=undefined
    mainPalette=undefined
    noise=undefined

    // Set seed
    seedRandom(seed, { global: true })
    seeded = random.createRandom(seed)
    noise = createNoise2D(alea(seed))
    let picked_width = seeded.pick([600,900,1200,1500,1800])
    let picked_height = seeded.pick([600,900,1200,1500,1800])
    let width = picked_width
    let height = picked_height
    let display_max = window.innerWidth > window.innerHeight ? window.innerHeight : window.innerWidth
    let size_max = display_max < 800 ? display_max : 800
    let largest = width > height ? width : height
    let display_ratio = size_max/largest
    let canvas_width = picked_width*display_ratio
    let canvas_height = picked_height*display_ratio
    setFeature('dimensions', `${width}x${height}`)

    // Create canvases

    const canvas = document.createElement('canvas')
    canvas.width = width*scale
    canvas.height = height*scale
    canvas.style = `width: ${canvas_width}px; height: ${canvas_height}px; position: absolute; z-index: 3`
    if (show) document.body.appendChild(canvas)
    const context = canvas.getContext('2d')
    context.scale(scale, scale)

    const canvas2 = document.createElement('canvas')
    canvas2.width = width*scale
    canvas2.height = height*scale
    canvas2.style = `width: ${canvas_width}px; height: ${canvas_height}px; position: absolute; z-index: 2`
    if (show) document.body.appendChild(canvas2)
    const context2 = canvas2.getContext('2d')
    context2.scale(scale, scale)

    const canvas3 = document.createElement('canvas')
    canvas3.width = width*scale
    canvas3.height = height*scale
    canvas3.style = `width: ${canvas_width}px; height: ${canvas_height}px; position: absolute; z-index: 1`
    if (show) document.body.appendChild(canvas3)
    const context3 = canvas3.getContext('2d')
    context3.scale(scale, scale)

    const canvas4 = document.createElement('canvas')
    canvas4.width = width*scale
    canvas4.height = height*scale
    canvas4.style = `width: ${canvas_width}px; height: ${canvas_height}px; position: absolute; z-index: 0`
    if (show) document.body.appendChild(canvas4)
    const context4 = canvas4.getContext('2d')
    context4.scale(scale, scale)

    let _colors = seeded.pick(palettes)
    mainPalette = _colors
    colors = _colors.palette
    setFeature('palette', _colors.name)
    c1 = seeded.pick(colors) 
    c2 = seeded.pick(colors.filter(c => c != c1)) 
    _c1 = rgbaColor(c1, 1) 
    _c2 = rgbaColor(c2, 1)
    let rows = seeded.pick([1,2,3,4,5,6])
    let columns = seeded.pick([1,2,3,4,5,6])
    let rowMargin = Math.floor(seeded.range(40,80))
    let frameWidth = 30
    let rowWidth = Math.floor((width - frameWidth*2 - rowMargin*(rows-1)) / rows)
    let rowHeight = Math.floor((height - frameWidth*2 - rowMargin*(columns-1)) / columns)
    let pixelSize = seeded.pick([1,1,1,1,1,1,2]) 
    //pixelSize = 1 // TODO: Remove
    setFeature('pixelsize', pixelSize)
    let generations = Math.round(seeded.range(50,200))
    //generations = 10 // TODO: Remove
    let borderSize = seeded.range(1,2)

    // Construct the grid

    let gridtype = seeded.range(0,10) >= 8 ? 'regular' : 'irregular'
    let grid = []
    setFeature('gridtype', gridtype)
    switch(gridtype) {
      case 'regular':
        grid = constructRegularGrid({ width, height, rows, columns, frameWidth, rowMargin, rowWidth, rowHeight })
        break;
      case 'irregular':
        grid = constructIrregularGridFull({ width, height, frameWidth })
        break;
    }

    // Paint backgrounds

    paintBackground(context, width, height)
    paintBackground(context2, width, height)
    paintBackground(context3, width, height)
    paintBackground(context4, width, height)

    // Paint the grid

    grid.forEach(square => {
      fillGridSquare({ context, canvas, square, pixelSize, frameWidth, color1: _c1, color2: _c2, golGenerations: generations })
      fillGridSquare({ context: context2, canvas: canvas2, square, pixelSize, frameWidth, color1: _c1, color2: _c2, golGenerations: generations })
      fillGridSquare({ context: context3, canvas: canvas3, square, pixelSize, frameWidth, color1: _c1, color2: _c2, golGenerations: generations })
      fillGridSquare({ context: context4, canvas: canvas4, square, pixelSize, frameWidth, color1: _c1, color2: _c2, golGenerations: generations })
    })

    // Paint overlay patterns 

    let overlay = seeded.pick(['lasers', 'circleblend', 'drops', 'lenses', 'squares','crazysquares','waves', 'tesseract', 'none'])
    setFeature('overlay', overlay)
    switch(overlay) {
      case 'lasers':
        drawOverlayLasers({ context, canvas, width, height, frameWidth, columns, rows, rowHeight, rowWidth, rowMargin, grid })
        grid.forEach(square => {
          paintGridSquareBorder({ context, square, borderSize })
        })
        break;
      case 'circleblend':
        drawOverlayCircleBlend({ context, canvas, width, height })
        grid.forEach(square => {
          paintGridSquareBorder({ context, square, borderSize })
        })
        break;
      case 'lenses':
        drawOverlayLenses({ context, canvas, context2, canvas2, context3, canvas3, context4, canvas4, width, height }) 
        grid.forEach(square => {
          paintGridSquareBorder({ context, square, borderSize })
        })
        break;
      case 'drops':
        drawOverlayDrops({ context, canvas, context2, canvas2, context3, canvas3, context4, canvas4, width, height })
        grid.forEach(square => {
          paintGridSquareBorder({ context, square, borderSize })
        })
        break;
      case 'squares':
        let options = [].concat(grid)
        Array.from(new Array(Math.round(seeded.range(1,grid.length)))).forEach(() => {
          let square = seeded.pick(options)
          options = options.filter(o => o != square)
          drawOverlaySquares({ context, canvas, context2, canvas2, context3, canvas3, context4, canvas4, width, height, square })
        })
        grid.forEach(square => {
          paintGridSquareBorder({ context, square, borderSize })
        })
        break;
      case 'crazysquares':
        drawOverlayCrazySquares({ context, canvas, width, height })
        grid.forEach(square => {
          paintGridSquareBorder({ context, square, borderSize })
        })
        break;
      case 'waves':
        drawOverlayWaves({ context, canvas, width, height, grid })
        grid.forEach(square => {
          paintGridSquareBorder({ context, square, borderSize })
        })
        break;
      case 'tesseract':
        drawOverlayTesseract({ context, canvas, width, height, frameWidth, grid, borderSize })
        break;
      case 'none':
        grid.forEach(square => {
          paintGridSquareBorder({ context, square, borderSize })
        })
        break;
    }

    let negative = (seeded.range(0,10) >= 9 && overlay != 'tesseract')
    setFeature('negative', negative)
    if (negative) {
      let negativeSquare = seeded.pick(grid)
      let _context = overlay == 'waves' ? context2 : context
      let _canvas  = overlay == 'waves' ? canvas2  : canvas
      createNegative({ context: _context, canvas: _canvas, x: negativeSquare.x, y: negativeSquare.y, w: negativeSquare.width, h: negativeSquare.height, width, height })
    }

  // Remove loader
  document.querySelectorAll('.loader').forEach(element => { element.remove() })

  // Fxpreview
  if (show) fxpreview()

  // Return for export merge
  return {
    canvases: [
      { canvas: canvas,  context: context },
      { canvas: canvas2, context: context2 },
      { canvas: canvas3, context: context3 },
      { canvas: canvas4, context: context4 },
    ],
    width,
    height,
    scale
  }

}

// Bind action keys

window.addEventListener('keydown', function (event) {
  if (event.key === 's')
    saveHighRes()
  if (['1','2','3','4','5','6','7','8','9'].indexOf(event.key) >= 0) {
    console.log('Setting scale: ', event.key)
    exportscale = event.key
  }
})

function saveHighRes() {
  const hr = sketch({ scale: exportscale, show: false }) 
  const merger = document.createElement('canvas')
  merger.width = hr.width*hr.scale 
  merger.height = hr.height*hr.scale
  console.log(`Exporting ${hr.width*hr.scale} x ${hr.height*hr.scale}`)
  const mcontext = merger.getContext('2d')
  const layers = hr.canvases.reverse()
  layers.forEach(c => {
    mcontext.drawImage(c.canvas, 0, 0)
  })
  var dataUrl = merger.toDataURL('image/png', 300)
  downloadURI(dataUrl, `${seed}.png`)
}

function downloadURI(uri, name) {
  var link = document.createElement('a');
  link.download = name;
  link.href = uri;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

function constructIrregularGridFull({ width, height, frameWidth }) {
  let gridDivsX = Math.round(width/100);
  let gridDivsY = Math.round(height/100);
  let gridPartWidth = Math.floor((width - frameWidth)/gridDivsX) 
  let gridPartHeight = Math.floor((height - frameWidth)/gridDivsY) 
  let grid = []
  let bools = []
  grid = constructIrregularGrid({ sizesArr: [2,3,4,5,6], gridDivsX, gridDivsY, rectInfo: grid, bools })
  grid = constructIrregularGrid({ sizesArr: [5], gridDivsX, gridDivsY, rectInfo: grid, bools })
  grid = constructIrregularGrid({ sizesArr: [4], gridDivsX, gridDivsY, rectInfo: grid, bools })
  grid = constructIrregularGrid({ sizesArr: [3], gridDivsX, gridDivsY, rectInfo: grid, bools })
  grid = constructIrregularGrid({ sizesArr: [2], gridDivsX, gridDivsY, rectInfo: grid, bools })
  grid = constructIrregularGrid({ sizesArr: [1], gridDivsX, gridDivsY, rectInfo: grid, bools })
  grid = grid.map(g => {
    return {
      x: g.x * gridPartWidth + frameWidth, 
      y: g.y * gridPartHeight + frameWidth,
      width:  g.width * gridPartWidth - frameWidth,
      height: g.height * gridPartHeight - frameWidth
    }
  })
  return grid
}

function constructRegularGrid({ width, height, rows, columns, frameWidth, rowMargin, rowWidth, rowHeight }) {
  let grid = []
  Array.from(new Array(rows)).forEach((r,i) => {
    Array.from(new Array(columns)).forEach((c,j) => {
      let x = frameWidth+rowWidth*i+rowMargin*i
      let width = rowWidth
      let y = frameWidth+rowHeight*j+rowMargin*j
      let height = rowHeight
      grid.push({ x, y, width, height })
    })
  })
  return grid
}

function max(arr) {
  return arr.sort().reverse()[0]
}

function constructIrregularGrid({ sizesArr, gridDivsX, gridDivsY, rectInfo, bools }){
  for(let x = 0; x<gridDivsX; x++){
    var column = [];
    for(let y = 0; y<gridDivsY; y++){
      column.push(1);
    }
    bools.push(column);
  }

  for(let x = 0; x<gridDivsX-max(sizesArr)+1; x++){
    for(let y = 0; y<gridDivsY-max(sizesArr)+1; y++){

      let xdim = seeded.pick(sizesArr)
      let ydim = seeded.pick(sizesArr)

      let fits = true

      // check if within bounds
      if(x + xdim > gridDivsX || y + ydim > gridDivsY){
        fits = false
      }

      // check if rectangle overlaps with any other rectangle
      if(fits){
        for(let xc = x; xc < x + xdim; xc++){
          for(let yc = y; yc < y + ydim; yc++){
            if(bools[xc][yc] == 0){
              fits = false
            }
          }
        }
      }

      if(fits){
        // mark area as occupied
        for(let xc = x; xc < x + xdim; xc++){
          for(let yc = y; yc < y + ydim; yc++){
            bools[xc][yc] = false
          }
        }

        rectInfo.push({x: x, y: y, width: xdim, height: ydim})
      }
    }
  }
  return rectInfo
}

function drawOverlayCircleBlend({ context, canvas, width, height }) {
  const rc = rough.canvas(canvas);
  const color = 'white' 
  context.globalCompositeOperation = 'destination-out' 
  context.fillStyle = color 
  Array.from(new Array(Math.round(seeded.range(5,20)))).forEach((a,i) => {
    const x = Math.round(seeded.range(0,width))
    const y = Math.round(seeded.range(0,height))
    const awidth = Math.round(seeded.range(0,width/2))
    const aheight = Math.round(seeded.range(0,height/2))
    const roughness = Math.round(seeded.range(10,20))
    rc.circle(x, y, awidth, { fill: color, stroke: 'transparent', fillStyle: 'solid', roughness: roughness })
  })
}

function drawOverlayDrops({ context, canvas, context2, canvas2, context3, canvas3, context4, canvas4, width, height }) {
  const rc = rough.canvas(canvas);
  const rc2 = rough.canvas(canvas2);
  const rc3 = rough.canvas(canvas3);
  const rc4 = rough.canvas(canvas4);
  const color = 'white' 
  let bgopposite = seeded.pick(colors.filter(c => c != bgColorLayer1))
  Array.from(new Array(Math.round(seeded.range(20,100)))).forEach((a,i) => {
    const x = Math.round(seeded.range(0,width))
    const y = Math.round(seeded.range(0,height))
    const awidth = Math.round(seeded.range(0,50))
    const aheight = Math.round(seeded.range(0,50))
    const roughness = Math.round(seeded.range(1,2))
    context.beginPath()
    switch(seeded.pick([1])) {
      case 1:
        context.globalCompositeOperation = 'destination-out' 
        context.fillStyle = color 
        rc.circle(x, y, awidth, { fill: color, stroke: 'transparent', fillStyle: 'solid', roughness: roughness })
        context.globalCompositeOperation = 'source-over' 
        break;
      case 2:
        context.globalCompositeOperation = 'destination-out' 
        context.fillStyle = color 
        context2.globalCompositeOperation = 'destination-out' 
        context2.fillStyle = color 
        rc.circle(x, y, awidth, { fill: color, stroke: 'transparent', fillStyle: 'solid', roughness: roughness })
        rc2.circle(x, y, awidth*2, { fill: color, stroke: 'transparent', fillStyle: 'solid', roughness: 0 })
        context.globalCompositeOperation = 'source-over' 
        context2.globalCompositeOperation = 'source-over' 
        break;
      case 3:
        context.globalCompositeOperation = 'destination-out' 
        context.fillStyle = color 
        context2.globalCompositeOperation = 'destination-out' 
        context2.fillStyle = color 
        context3.globalCompositeOperation = 'destination-out' 
        context3.fillStyle = color 
        rc.circle(x, y, awidth, { fill: color, stroke: 'transparent', fillStyle: 'solid', roughness: roughness })
        rc2.circle(x, y, awidth*2, { fill: color, stroke: 'transparent', fillStyle: 'solid', roughness: 0 })
        rc3.circle(x, y, awidth*2, { fill: color, stroke: 'transparent', fillStyle: 'solid', roughness: 0 })
        context.globalCompositeOperation = 'source-over' 
        context2.globalCompositeOperation = 'source-over' 
        context3.globalCompositeOperation = 'source-over' 
        break;
    }
    context.closePath()
  })
}

function drawOverlayLenses({ context, canvas, context2, canvas2, context3, canvas3, context4, canvas4, width, height }) {
  const rc = rough.canvas(canvas);
  const rc2 = rough.canvas(canvas2);
  const rc3 = rough.canvas(canvas3);
  const rc4 = rough.canvas(canvas4);
  const color = 'white' 
  let min = width/10
  let max = width/1.5
  let bgopposite = seeded.pick(colors.filter(c => c != bgColorLayer1))
  let fillStyle = seeded.pick(['solid','zigzag'])
  let circle1, circle2;
  Array.from(new Array(Math.round(seeded.range(1, 1)))).forEach((c,i) => {
    const x = seeded.range(0, width)
    const y = seeded.range(0, height) 
    const awidth = Math.round(seeded.range(min, max))
    const aheight = Math.round(seeded.range(min, max))
    const roughness = Math.round(seeded.range(0,0))
    context.beginPath()
    context.globalCompositeOperation = 'destination-out' 
    context.fillStyle = color 
    context3.globalCompositeOperation = 'destination-out' 
    context3.fillStyle = color 
    rc.circle(x, y, awidth, { fill: 'white', stroke: 'transparent', fillStyle: 'solid', roughness: roughness })
    rc3.circle(x, y, awidth, { fill: 'white', stroke: 'transparent', fillStyle: 'solid', roughness: roughness })
    context.closePath()
    context.beginPath()
    context.globalCompositeOperation = 'source-over' 
    context.fillStyle = color 
    context2.globalCompositeOperation = 'source-over' 
    context2.fillStyle = color 
    context3.globalCompositeOperation = 'source-over' 
    context3.fillStyle = color 
    rc.circle(x, y, awidth, { fill: 'transparent', stroke: rgbaColor(bgopposite), fillStyle: 'solid', roughness: roughness, strokeWidth: 2 })
    rc2.circle(x, y, awidth, { fill: 'transparent', stroke: rgbaColor(bgopposite), fillStyle: 'solid', roughness: roughness, strokeWidth: 2 })
    rc3.circle(x, y, awidth, { fill: 'transparent', stroke: rgbaColor(bgopposite), fillStyle: 'solid', roughness: roughness, strokeWidth: 2 })
    context.closePath()
  })
  Array.from(new Array(Math.round(seeded.range(1, 1)))).forEach((c,i) => {
    const x = seeded.range(0, width)
    const y = seeded.range(0, height) 
    const awidth = Math.round(seeded.range(min, max))
    const aheight = Math.round(seeded.range(min, max))
    const roughness = Math.round(seeded.range(0,0))
    context.beginPath()
    context.globalCompositeOperation = 'destination-out' 
    context.fillStyle = color 
    context2.globalCompositeOperation = 'destination-out' 
    context2.fillStyle = color 
    rc.circle(x, y, awidth, { fill: 'white', stroke: 'transparent', fillStyle: 'solid', roughness: roughness })
    rc2.circle(x, y, awidth, { fill: 'white', stroke: 'transparent', fillStyle: 'solid', roughness: roughness })
    context.closePath()
    context.beginPath()
    context.globalCompositeOperation = 'source-over' 
    context.fillStyle = color 
    context2.globalCompositeOperation = 'source-over' 
    context2.fillStyle = color 
    context3.globalCompositeOperation = 'source-over' 
    context3.fillStyle = color 
    rc.circle(x, y, awidth, { fill: 'transparent', stroke: rgbaColor(bgopposite), fillStyle: 'solid', roughness: roughness, strokeWidth: 2 })
    rc2.circle(x, y, awidth, { fill: 'transparent', stroke: rgbaColor(bgopposite), fillStyle: 'solid', roughness: roughness, strokeWidth: 2 })
    rc3.circle(x, y, awidth, { fill: 'transparent', stroke: rgbaColor(bgopposite), fillStyle: 'solid', roughness: roughness, strokeWidth: 2 })
    context.closePath()
  })
  if (seeded.range(0,10) >= 9) {
    Array.from(new Array(Math.round(seeded.range(1, 1)))).forEach((c,i) => {
      const x = seeded.range(0, width)
      const y = seeded.range(0, height) 
      const awidth = Math.round(seeded.range(min, max))
      const aheight = Math.round(seeded.range(min, max))
      const roughness = Math.round(seeded.range(0,0))
      context.beginPath()
      context2.globalCompositeOperation = 'destination-out' 
      context2.fillStyle = color 
      context3.globalCompositeOperation = 'destination-out' 
      context3.fillStyle = color 
      rc2.circle(x, y, awidth, { fill: 'white', stroke: 'transparent', fillStyle: 'solid', roughness: roughness })
      rc3.circle(x, y, awidth, { fill: 'white', stroke: 'transparent', fillStyle: 'solid', roughness: roughness })
      context.closePath()
      context.beginPath()
      context.globalCompositeOperation = 'source-over' 
      context.fillStyle = color 
      context2.globalCompositeOperation = 'source-over' 
      context2.fillStyle = color 
      context3.globalCompositeOperation = 'source-over' 
      context3.fillStyle = color 
      rc.circle(x, y, awidth, { fill: rgbaColor(bgopposite), stroke: rgbaColor(bgopposite), fillStyle: 'dashed', roughness: roughness, strokeWidth: 2 })
      rc2.circle(x, y, awidth, { fill: 'transparent', stroke: rgbaColor(bgopposite), fillStyle: 'solid', roughness: roughness, strokeWidth: 2 })
      rc3.circle(x, y, awidth, { fill: 'transparent', stroke: rgbaColor(bgopposite), fillStyle: 'solid', roughness: roughness, strokeWidth: 2 })
      context.closePath()
    })
  }
}

function drawOverlaySquares({ context, canvas, context2, canvas2, context3, canvas3, context4, canvas4, width, height, square }) {
  let rc = rough.canvas(canvas);
  let rc2 = rough.canvas(canvas2);
  let rc3 = rough.canvas(canvas3);
  let rc4 = rough.canvas(canvas4);
  let color = 'white' 
  let _width = square.width
  let _height = square.height
  let startX = square.x
  let startY = square.y
  let squareWidth = Math.round(seeded.range(_width/10,_width/5))
  let squareHeight = Math.round(seeded.range(_height/10,_height/5))
  let overlap = Math.round(seeded.range(0,10))
  let columns = Math.floor(_width/squareWidth) // Adding X (5,10) creates an overlap, kinda cool
  let rows = Math.floor(_height/squareHeight)
  let colspacing = (_width - columns*squareWidth) / columns
  let rowspacing = (_height - rows*squareHeight) / rows
  let bgopposite = seeded.pick(colors.filter(c => c != bgColorLayer1))
  let wo = seeded.range(0,width)
  let roughness = Math.round(seeded.range(0,1))
  Array.from(new Array(columns)).forEach((a,i) => {
    Array.from(new Array(rows)).forEach((b,j) => {
      const bleed = seeded.range(0,10) >= 6
      const x = startX+squareWidth*i+colspacing*i
      const y = startY+squareHeight*j+rowspacing*j
      const w = squareWidth+colspacing
      const h = squareHeight+rowspacing
      if (bleed) {
        context.beginPath()
        context2.beginPath()
        context3.beginPath()
        context.globalCompositeOperation = 'destination-out' 
        context.fillStyle = color
        context2.globalCompositeOperation = 'destination-out' 
        context2.fillStyle = color
        context3.globalCompositeOperation = 'destination-out' 
        context3.fillStyle = color
        switch(seeded.pick([1,2,3])) {
          case 1:
            rc.rectangle(x, y, w, h, { fill: color, stroke: 'transparent', fillStyle: 'solid', roughness: roughness })
            break;
          case 2:
            rc.rectangle(x, y, w, h, { fill: color, stroke: 'transparent', fillStyle: 'solid', roughness: roughness })
            rc2.rectangle(x, y, w, h, { fill: color, stroke: 'transparent', fillStyle: 'solid', roughness: roughness })
            break;
          case 3:
            rc.rectangle(x, y, w, h, { fill: color, stroke: 'transparent', fillStyle: 'solid', roughness: roughness })
            rc2.rectangle(x, y, w, h, { fill: color, stroke: 'transparent', fillStyle: 'solid', roughness: roughness })
            rc3.rectangle(x, y, w, h, { fill: color, stroke: 'transparent', fillStyle: 'solid', roughness: roughness })
            break;
        }
        context.closePath()
        context2.closePath()
        context3.closePath()
      }
      context.beginPath()
      context.globalCompositeOperation = 'source-over' 
      rc.rectangle(x, y, w, h, { fill: 'transparent', stroke: rgbaColor(bgopposite), fillStyle: 'solid', roughness: roughness, strokeWidth: seeded.range(1,2) })
      context.closePath()
    })
  })
}

function drawOverlayCrazySquares({ context, canvas, width, height }) {
  let rc = rough.canvas(canvas);
  let color = 'white' 
  let squareSize = Math.round(seeded.range(80,120))
  let _width = width*2
  let _height = height*2
  let overlap = Math.round(seeded.range(0,10))
  let columns = Math.floor(_width/squareSize)+overlap // Adding X (5,10) creates an overlap, kinda cool
  let rows = Math.floor(_height/squareSize)+overlap
  let colspacing = (_width - columns*squareSize) / columns
  let rowspacing = (_height - rows*squareSize) / rows
  context.globalCompositeOperation = 'destination-out' 
  context.fillStyle = color
  let degs = Math.round(seeded.range(-45,45))
  context.rotate(degs * Math.PI / 180)
  let wo = seeded.range(0,width)
  Array.from(new Array(columns)).forEach((a,i) => {
    Array.from(new Array(rows)).forEach((b,j) => {
      const bleed = seeded.range(0,10) >= 6
      const x = squareSize*i+colspacing*i-wo
      const y = squareSize*j+rowspacing*j-wo
      const w = squareSize
      const h = squareSize 
      let roughness = Math.round(seeded.range(2,4))
      if (bleed) {
        rc.rectangle(x, y, w, h, { fill: color, stroke: 'transparent', fillStyle: 'solid', roughness: roughness })
      } else {
        rc.rectangle(x, y, w, h, { fill: 'transparent', stroke: color, fillStyle: 'solid', roughness: roughness })
      }
    })
  })
}

function drawOverlayWaves({ context, canvas, width, height, grid }) {
    var xoff = 0;
    var yoff = 0;
    var inc = seeded.range(0.01,0.01);
    let size = 2
    let direction = width > height ? width : height
    var civilizations = [
        {x: width/2, y: height/2, radius: direction/size}, 
    ];
    const curve_1 = seeded.range(5,5)
    const curve_2 = seeded.range(1,3)
    const lineWidth = seeded.range(1,2)
    let bgopposite = seeded.pick(colors.filter(c => c != bgColorLayer1))
    context.strokeStyle=rgbaColor(bgopposite, seeded.range(0.2,0.4))
    for (var i = 0; i < civilizations.length; i++) {
      var civilization = civilizations[i];
      for (var y = civilization.y - civilization.radius; y <= civilization.y + civilization.radius; y += curve_1) {
        xoff = 0;
        context.beginPath();
        context.lineWidth = lineWidth 
        for (var x = civilization.x - civilization.radius; x <= civilization.x + civilization.radius; x += curve_2) {
            var distance = dist(x, y, civilization.x, civilization.y);
            var angle = map(distance, 0, civilization.radius, 0, TWO_PI);
            var x1 = x + 10 * Math.cos(angle + noise(xoff, yoff) * TWO_PI);
            var y1 = y + 10 * Math.sin(angle + noise(xoff, yoff) * TWO_PI);
            context.lineTo(x1, y1);
            xoff += inc;
        }
        yoff += inc;
        context.stroke();
      }
    }
  grid.forEach(square => {
    context.globalCompositeOperation = 'destination-out'
    context.fillStyle='white'
    context.fillRect(square.x, square.y, square.width, square.height)
  })
}

function drawOverlayTesseract({ context, canvas, width, height, frameWidth, grid, borderSize }) {

  // Prep grid

  let bgopposite = seeded.pick(colors.filter(c => c != bgColorLayer1))
  let cut = Math.round(seeded.range(20,30))
  grid.forEach(square => {
    context.fillStyle = rgbaColor(bgColorLayer1)
    context.strokeStyle = rgbaColor(bgColorLayer1)
    context.fillRect(square.x, square.y, square.width, cut) 
    context.fillRect(square.x+square.width-cut, square.y, cut, square.height) 
    context.lineWidth = 1 
    context.strokeStyle = rgbaColor(bgopposite)
    context.beginPath()
    context.moveTo(square.x, square.y+cut)
    context.lineTo(square.x+square.width-cut, square.y+cut)
    context.lineTo(square.x+square.width-cut, square.y+square.height)
    context.lineTo(square.x+square.width, square.y+square.height-cut)
    context.lineTo(square.x+square.width, square.y)
    context.lineTo(square.x+square.width-cut, square.y+cut)
    context.moveTo(square.x+square.width, square.y)
    context.lineTo(square.x+cut, square.y)
    context.lineTo(square.x, square.y+cut)
    context.lineTo(square.x, square.y+square.height)
    context.lineTo(square.x+square.width-cut, square.y+square.height)
    context.stroke()
    context.closePath()
    if (seeded.range(0,10) >= 7) {
      context.beginPath()
      context.globalCompositeOperation = 'destination-out'
      context.fillStyle='white'
      context.moveTo(square.x+square.width-cut, square.y+cut)
      context.lineTo(square.x+square.width-cut, square.y+square.height)
      context.lineTo(square.x+square.width, square.y+square.height-cut)
      context.lineTo(square.x+square.width, square.y)
      context.lineTo(square.x+square.width-cut, square.y+cut)
      context.fill()
      context.closePath()
      context.globalCompositeOperation = 'source-over'
    } else if (seeded.range(0,10) >= 5) {
      context.beginPath()
      context.fillStyle = rgbaColor(bgopposite, seeded.range(0.4,0.8))
      context.moveTo(square.x+square.width-cut, square.y+cut)
      context.lineTo(square.x+square.width-cut, square.y+square.height)
      context.lineTo(square.x+square.width, square.y+square.height-cut)
      context.lineTo(square.x+square.width, square.y)
      context.lineTo(square.x+square.width-cut, square.y+cut)
      context.fill()
      context.closePath()
    }
  })

  let lineWidth = Math.round(seeded.range(10, 20))
  let _degs = cut 
  let tesseractLines = seeded.pick([4,5,6,7,8])
  let colorMode = seeded.pick(['bgopposite', 'transparent'])
  colorMode = 'bgopposite'
  let availableColors = [[255,0,0]]
  let opacityLottery = true 
  switch(colorMode) {
    case 'bgopposite':
      availableColors = [bgopposite]
      break;
    case 'transparent':
      availableColors = [undefined]
      break;
  } 
  let placements = []
  let cutlwdiff = cut-lineWidth
  let gap = Math.round(seeded.range(1,2))
  let slimlinewidth = lineWidth/5
  let slimline = seeded.range(0,10) >= 7
  Array.from(new Array(tesseractLines)).forEach((l,li) => {
    let x = findTesseractStartX({ grid, placements, lineWidth, cut, gap })
    let y = 0
    let splitline = seeded.range(0,10) >= 8
    let splitlinegap = 1
    let splits = Math.round(seeded.range(3,5))
    let color = seeded.pick(availableColors)
    if (color && opacityLottery)
      color = rgbaColor(color, seeded.range(0.4,1))
    else if (color && !opacityLottery)
      color = rgbaColor(color, 1)

    // Fall loop

    let cubeTop = findNextCubeTop({ grid, height, lineWidth, cut, x, y })
    while(cubeTop < height) {
      context.beginPath()
      context.fillStyle=color
      // See-through maybe
      if (seeded.range(0,10) >= 7)
        context.globalCompositeOperation = 'destination-out'

      // Draw straight fall
      if (slimline) {
        context.fillRect(x-slimlinewidth+lineWidth/2, y, slimlinewidth, cubeTop-y)
      } else if (splitline) {
        let _lineWidth = ((lineWidth/splits) - splitlinegap)
        Array.from(new Array(splits)).forEach((s,i) => {
          context.fillRect(x+_lineWidth*i+splitlinegap*i, y, _lineWidth, cubeTop-y)
        })
      } else {
        context.fillRect(x, y, lineWidth, cubeTop-y)
      }

      // Close see-through
      context.closePath()
      context.globalCompositeOperation = 'source-over'
      if (cubeTop < height) {
        // Draw angle
        context.beginPath()
        if (seeded.range(0,10) >= 7)
          context.globalCompositeOperation = 'destination-out'
        context.moveTo(x, cubeTop)
        context.lineTo(x-cut, cubeTop+cut)
        context.lineTo(x-cutlwdiff, cubeTop+cut)
        context.lineTo(x+cut-cutlwdiff, cubeTop)
        context.lineTo(x, cubeTop)
        context.fill()
        context.closePath()
        context.globalCompositeOperation = 'source-over'
      }
      y = cubeTop+cut
      x = x-cut
      cubeTop = findNextCubeTop({ grid, height, lineWidth, cut, x, y })
    }
    // Fall to the abyss
    context.beginPath()
    context.fillStyle=color
    if (slimline) {
      context.fillRect(x-slimlinewidth+lineWidth/2, y, slimlinewidth, cubeTop-y)
    } else if (splitline) {
      let _lineWidth = ((lineWidth/splits) - splitlinegap)
      Array.from(new Array(splits)).forEach((s,i) => {
        context.fillRect(x+_lineWidth*i+splitlinegap*i, y, _lineWidth, cubeTop-y)
      })
    } else {
      context.fillRect(x, y, lineWidth, cubeTop-y)
    }
    context.closePath()
  })
}

function findTesseractStartX({ grid, placements, lineWidth, cut, gap }) {
  // Pick square
  let square = seeded.pick(grid)
  let xmin = square.x+cut
  let xmax = square.x+square.width-lineWidth

  let x = Math.round(seeded.range(xmin, xmax))
  let overlap = placements.filter(x2 => {
    let xmin = x
    let xmax = x+lineWidth
    let x2min = x2
    let x2max = x2+lineWidth
    return (xmax >= x2min && xmax <= x2max) || (xmin >= x2min && xmin <= x2max)
  })[0]
  if (overlap) {
    let availableSpaceLeft = xmin < overlap-lineWidth
    let availableSpaceRight = xmax > overlap+lineWidth*2
    if (availableSpaceLeft)
      x = overlap-lineWidth-gap
    else if (availableSpaceRight)
      x = overlap+lineWidth*2+gap
    else
      x = null
  }
  let new_x_overlap = placements.filter(x2 => {
    let xmin = x
    let xmax = x+lineWidth
    let x2min = x2
    let x2max = x2+lineWidth
    return (xmax >= x2min && xmax <= x2max) || (xmin >= x2min && xmin <= x2max)
  })[0]
  if (new_x_overlap) x = null

  if (x == null)
    x = findTesseractStartX({ grid, placements, lineWidth, cut, gap })
  else 
    placements.push(x) 
  return x
}

function findNextCubeTop({ grid, height, lineWidth, cut, x, y }) {
  let top = height
  grid.forEach(square => {
    if (square.y > y) {
      if (square.x+cut <= x && square.x+square.width >= x+lineWidth) {
        if (square.y < top) {
          top = square.y
        }
      }
    }
  })
  return top
}

function drawOverlayDeglines({ context, canvas, width, height, frameWidth }) {
  let numOverlayLines = seeded.pick([3,4,5,6])
  let startX = seeded.range(0, width)
  let direction = startX > width/2 ? -1 : 1 
  let lineWidth = Math.round(seeded.range(40, 80))
  let lineSpace = Math.round(seeded.range(20, 80))
  const degs = Math.round(seeded.pick([seeded.range(-300, -100),seeded.range(300, 100)]))
  let varyLineSpace = seeded.range(0,10) >= 5
  let varyLineWidth = seeded.range(0,10) >= 5
  Array.from(new Array(numOverlayLines)).forEach((l,i) => {
    if (varyLineWidth) lineWidth = Math.round(seeded.range(40, 80))
    if (varyLineSpace) lineSpace = Math.round(seeded.range(20, 80))
    overlayLine({ context, width, height, frameWidth, startX: startX+i*lineWidth*direction+i*lineSpace*direction, startY: 0, endY: height, lineWidth: lineWidth, degs: degs })
  })
}

function drawOverlayLasers({ context, canvas, width, height, frameWidth, grid }) {
  let numOverlayLines = seeded.pick([2,3,4,5])
  let startX = seeded.range(0, width)
  let direction = startX > width/2 ? -1 : 1 
  let lineWidth = Math.round(seeded.range(2, 4))
  let lineSpace = Math.round(seeded.range(20, 80))
  let degs = 0  
  let laserDotMargin = seeded.range(10,15)
  let varyLineSpace = seeded.range(0,10) >= 5
  let varyLineWidth = seeded.range(0,10) >= 5
  const bgopposite = rgbaColor(seeded.pick(colors.filter(c => c != bgColorLayer1)))
  Array.from(new Array(numOverlayLines)).forEach((l,i) => {
    if (varyLineSpace) lineSpace = Math.round(seeded.range(20, 80))
    if (varyLineWidth) lineWidth = Math.round(seeded.range(2, 4))
    let _startX = startX+i*lineWidth*direction+i*lineSpace*direction
    overlayLine({ context, width, height, frameWidth, startX: _startX, startY: 0, endY: height, lineWidth: lineWidth, degs: degs, color: bgopposite })
    grid.forEach((s,i) => {
      let hit = (_startX >= s.x && _startX <= (s.x+s.width))
      if (hit) {
        const holes = Math.round(seeded.range(s.height/4,s.height/2))
        Array.from(new Array(holes)).forEach((l,hi) => {
          const _startY = s.y 
          const x = seeded.range(-laserDotMargin,laserDotMargin)
          const y = seeded.range(_startY-laserDotMargin,_startY+s.height+laserDotMargin)
          const r = seeded.range(1,lineWidth)
          context.beginPath()
          context.globalCompositeOperation = 'destination-out'
          context.arc(_startX+x, y, r, 0, 2 * Math.PI)
          context.fillStyle='white'
          context.fill()
          context.globalCompositeOperation = 'source-over' 
          context.closePath()
        }) 
      }
    })
  })
}

function overlayLine({ context, width, height, frameWidth, startX, startY, endY, lineWidth, degs, color }) {
  context.save()
  context.beginPath()
  if (!color) context.globalCompositeOperation = 'destination-out'
  else context.fillStyle = color
  context.moveTo(startX, startY)
  context.lineTo(startX-degs, endY)
  context.lineTo(startX-degs+lineWidth, endY)
  context.lineTo(startX+lineWidth, startY)
  context.fill()
  context.closePath()
  context.restore()
}

function fillGridSquare({ context, canvas, square, pixelSize, frameWidth, color1, color2, golGenerations }) {
  if (seeded.range(0,10) <= 8)
    paintLife({ 
      context, 
      startX: square.x, 
      startY: square.y, 
      height: square.height, 
      width: square.width,
      pixelSize, 
      color1, 
      color2, 
      frameWidth, 
    })
  else
    paintGameOfLife({ 
      context, 
      canvas, 
      startX: square.x, 
      endX: square.x+square.width, 
      startY: square.y, 
      endY: square.y+square.height, 
      pixelSize, 
      generations: golGenerations
    }) 
}

function paintGridSquareBorder({ context, borderColor, borderSize, square }) {
  borderColor = borderColor || rgbaColor(seeded.pick(colors.filter(c => c != bgColorLayer1)))
  context.strokeStyle=borderColor
  context.lineWidth=borderSize
  context.strokeRect(square.x, square.y, square.width, square.height)
}

function paintLife({ context, startX, startY, height, width, pixelSize, frameWidth }) {
    let rows = Math.floor(height / pixelSize)
    let pixels = Math.floor(width / pixelSize)
    let initialRow = Array.from(new Array(pixels)).map(i => seeded.pick([0,1]))
    let algoSwapLottery = Math.round(seeded.range(5,100))
    let algoSwap = Array.from(new Array(algoSwapLottery)).reduce((swaps, i) => {
      let index = Math.round(seeded.range(1,rows))
      let s = { index: index, flag: seeded.pick(['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eight']) }
      swaps[index] = s
      return swaps
    },{})
    let grid = [initialRow]
    let currentRow = null 
    let i = 0
    let genNextRow = generateNextRow.bind({ 
      first: seeded.pick([0,1]), 
      second: 0, 
      third: 1, 
      fourth: 1, 
      fifth: 0, 
      sixth: 1, 
      seventh: 0, 
      eight: 1 
    })
    while (grid.length < rows) {
      currentRow = grid[i]
      grid.push(genNextRow({ currentRow, swapAlgo: algoSwap[i], rowIndex: i }))
      i++
    }
    paintGrid({ context, grid, pixelSize, startX, startY })
}

function paintGameOfLife({ startX, endX, startY, endY, pixelSize, canvas, context, generations }) {
  let grid = generateGrid({ startX, endX, startY, endY, pixelSize })
  Array.from(new Array(generations)).forEach(() => {
    grid = updateCells({ grid })
  })
  drawCells({ canvas, context: context, grid, startX, startY, pixelSize })
}

function generateNextRow({ currentRow, swapAlgo, rowIndex }) {
  if (swapAlgo) {
    this[swapAlgo.flag] = this[swapAlgo.flag] ? 0 : 1 
  }
  const nextRow = currentRow.map((pixel, x) => {
    const prev_pixel = x > 0 ? currentRow[x-1] : seeded.pick([0,1])
    const next_pixel = x < currentRow.length-1 ? currentRow[x+1] : seeded.pick([0,1])
    const this_pixel = pixel
    let n = 0
    if (prev_pixel && this_pixel && next_pixel) n = this.first
    if (prev_pixel && this_pixel && !next_pixel) n = this.second
    if (prev_pixel && !this_pixel && !next_pixel) n = this.third 
    if (!prev_pixel && !this_pixel && !next_pixel) n = this.fourth
    if (!prev_pixel && !this_pixel && next_pixel) n = this.fifth
    if (!prev_pixel && this_pixel && next_pixel) n = this.sixth
    if (!prev_pixel && this_pixel && !next_pixel) n = this.seventh
    if (prev_pixel && !this_pixel && next_pixel) n = this.eight
    return n
  })
  return nextRow
}

function paintBackground(context, width, height) {
  context.beginPath()
  let c = seeded.pick(colors)
  if (!bgColorLayer1) bgColorLayer1 = c
  else c = seeded.pick(colors.filter(c => c != bgColorLayer1)) 
  context.fillStyle = rgbaColor(c)
  context.fillRect(0,0, width, height)
  context.closePath()
}

function paintGrid({ context, grid, pixelSize, startX, startY }) {
  context.beginPath()
  grid.forEach((row,y) => {
    row.forEach((pixel,x) => {
      context.fillStyle = pixel ? _c1 : _c2 // if 1, color depending on x % 3 (or something)
      context.fillRect(startX+x*pixelSize,startY+y*pixelSize, pixelSize, pixelSize)
    })
  })
  context.closePath()
}

// GOL

// Create a grid of cells with random starting state
function generateGrid({ startX, endX, startY, endY, pixelSize }) {
  const grid = [];
  const num_rows = Math.floor((endX-startX) / pixelSize)
  const num_columns = Math.floor((endY-startY) / pixelSize)
  Array.from(new Array(num_rows)).forEach((r,x) => {
    const row = []
    Array.from(new Array(num_columns)).forEach((r,y) => {
      row.push(seeded.range(0,1) < 0.5)
    }) 
    grid.push(row)
  })
  return grid
}

// Function to update the state of each cell based on the state of its neighbors
function updateCells({ grid }) {
  const gridSize = grid.length
  const newGrid = [];
  grid.forEach((_row, i) => {
    const row = [];
    _row.forEach((pixel, j) => { 
      let aliveNeighbors = 0;
      for (let ni = -1; ni <= 1; ni++) {
        for (let nj = -1; nj <= 1; nj++) {
          if (ni === 0 && nj === 0) continue;
          if (grid[(i + ni + gridSize) % gridSize][(j + nj + gridSize) % gridSize]) {
            aliveNeighbors++;
          }
        }
      }
      // Use a simple rule to update the state of the cell
      if (aliveNeighbors === 3) {
        row.push(true)
      } else if (aliveNeighbors === 2) {
        row.push(pixel)
      } else {
        row.push(false)
      }
    })
    newGrid.push(row);
  })
  return newGrid;
}

function drawCells({ canvas, context, grid, pixelSize, startX, startY }) {
  context.beginPath()
  grid.forEach((row, x) => {
    row.forEach((pixel, y) => {
      context.fillStyle = pixel ? _c1 : _c2
      context.fillRect(startX+x*pixelSize, startY+y*pixelSize, pixelSize, pixelSize);
    })
  })
  context.closePath()
}

function createNegative({ context, canvas, x, y, w, h, width, height }) {
  let wr = canvas.width / width
  let hr = canvas.height / height
  var imageData = context.getImageData(x*wr, y*hr, w*wr, h*hr);
  var dataArr = imageData.data;
  for(var i = 0; i < dataArr.length; i += 4)
  {
      var r = dataArr[i]; // Red color lies between 0 and 255
      var g = dataArr[i + 1]; // Green color lies between 0 and 255
      var b = dataArr[i + 2]; // Blue color lies between 0 and 255
      var a = dataArr[i + 3]; // Transparency lies between 0 and 255

      var invertedRed = 255 - r;
      var invertedGreen = 255 - g;
      var invertedBlue = 255 - b;

      dataArr[i] = invertedRed;
      dataArr[i + 1] = invertedGreen;
      dataArr[i + 2] = invertedBlue;
  }
  context.putImageData(imageData, x*wr, y*hr);
}

setTimeout(() => {
  sketch({ scale: 1, show: true });
},100)
